import { Injectable } from '@angular/core';
import { EventBus as EventBusService, EventBusBase } from '@skylab-shared/core';
import { Wrapper } from '../wrapper/wrapper';

export { EventBusBase };

@Injectable({ providedIn: 'root' })
@Wrapper(EventBusService, { static: true })
export class EventBus { }
